<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/176ykXL/tc-custom/9781466847644.jpg?1729379729103" alt="This image is the cover for the book Luna: Wolf Moon"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Luna: Wolf Moon
      </h1>
      <p class="bookDescription body article font2">
        <p>A Dragon is dead. <br/><br/> Corta Helio, one of the five family corporations that rule the Moon, has fallen.  Its riches are divided up among its many enemies, its survivors scattered. Eighteen months have passed . <br/><br/> The remaining Helio children, Lucasinho and Luna, are under the protection of the powerful Asamoahs, while Robson, still reeling from witnessing his parent’s violent deaths, is now a ward--virtually a hostage--  of Mackenzie Metals. And the last appointed heir, Lucas, has vanished of the surface of the moon. <br/><br/>Only Lady Sun, dowager of Taiyang, suspects that Lucas Corta is not dead, and more to the point—that he is still a major player in the game.  After all, Lucas always was the Schemer, and even in death, he would go to any lengths to take back everything and build a new Corta Helio, more powerful than before. But Corta Helio needs allies, and to find them, the fleeing son undertakes an audacious, impossible journey--to Earth. <br/><br/>In an unstable lunar environment, the shifting loyalties and political machinations of each family reach the zenith of their most fertile plots as outright war erupts.<br/><br/><i>Luna: Wolf Moon </i>continues Ian McDonald's saga of the Five Dragons.<br/><br/><b>Luna </b><br/>1. <i>Luna: New Moon</i><br/><b>2.<i> Luna: Wolf Moon</i></b><br/>3. <i>Luna: Moon Rising</i><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ian McDonald
      </h2>
      
      <p class="authorDescription body article">Ian McDonald was born in 1960 in Manchester, England, to an Irish mother and a Scottish father. He moved with his family to Northern Ireland in 1965. He used to live in a house built in the back garden of C. S. Lewis&rsquo;s childhood home but has since moved to central Belfast, where he now lives, exploring interests like cats, contemplative religion, bonsai, bicycles, and comic-book collecting. He debuted in 1982 with the short story &ldquo;The Island of the Dead&rdquo; in the short-lived British magazine <i>Extro</i>. His first novel, <i>Desolation Road</i>, was published in 1988. Other works include <i>King of Morning</i>,<i> Queen of Day </i>(winner of the Philip K. Dick Award), <i>River of Gods</i>, <i>The Dervish House</i> (both of which won British Science Fiction Association Awards), the graphic novel <i>Kling Klang Klatch,</i> and many more. His most recent publications are <i>Planesrunner </i>and <i>Be My Enemy</i>, books one and two of the Everness series for younger readers (though older readers will find them a ball of fun, as well). Ian worked in television development for sixteen years, but is glad to be back to writing fulltime.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1e44d7f0